module.exports = __webpack_public_path__ + "static/img/block_syds_0601.10e05cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/homepage/block_syds_0601.jpg
// module id = TVZI
// module chunks = 1